export default __webpack_public_path__ + "static/media/closet5-before3-2048w.68f87640.webp";